import React, { useEffect } from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Accordion from 'react-bootstrap/Accordion'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiSave } from 'react-icons/fi'
import { GiBulletBill } from 'react-icons/gi'
import { IoIosAdd } from 'react-icons/io'
import { TiUserDelete } from 'react-icons/ti'
import { BiImport } from 'react-icons/bi'
import './index.css'
import { GetRiders, AddTeam, GetUser, GetLeaguesByIds, GetMatchingTeams, GetTeamRiders } from '../../ApiRequests'
import Helmet from 'react-helmet'


const CreateTeam = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const _leagueId = params.get('leagueId');

    const [league, setLeague] = useState({})
    const [leagueId, setLeagueId] = useState('')
    const [riders, setRiders] = useState([])
    const [filteredRiders, setFilteredRiders] = useState(riders)
    const [team, setTeam] = useState([])
    const [maleCount, setMaleCount] = useState(0)
    const [femaleCount, setFemaleCount] = useState(0)
    const [numMaleRiders, setNumMaleRiders] = useState(4)
    const [numFemaleRiders, setNumFemaleRiders] = useState(2)
    const [teamValue, setTeamValue] = useState(0)
    const [genderFilter, setGenderFilter] = useState('All')
    const [countryFilter, setCountryFilter] = useState('All')
    const [countries, setCountries] = useState([])

    const [showImportTeam, setShowImportTeam] = useState(false)
    const [matchingTeams, setMatchingTeams] = useState([])

    //Add a rider to the team
    const addToTeam = async (rider) => {
        if (rider.gender == 'f' && femaleCount < numFemaleRiders) {
            // Add the female rider to the team
            setFemaleCount(femaleCount + 1);
            setTeamValue(teamValue + rider.value)
            setTeam(prevTeam => [...prevTeam, rider])
        } else if (rider.gender == 'm' && maleCount < numMaleRiders) {
            // Add the male rider to the team
            setMaleCount(maleCount + 1);
            setTeamValue(teamValue + rider.value)
            setTeam(prevTeam => [...prevTeam, rider])
        }
    }

    //Remove a rider from the team
    const removeFromTeam = (rider) => {
        if (rider.gender == 'f') {
            // Add the female rider to the team
            setFemaleCount(femaleCount - 1);
        } else if (rider.gender == 'm') {
            // Add the male rider to the team
            setMaleCount(maleCount - 1);
        }
        const updatedTeam = team.filter(r => r._id !== rider._id);
        setTeam(updatedTeam);
        setTeamValue(teamValue - rider.value)
    }


    const checkIfUserInLeague = async () => {
        const userId = localStorage.getItem('userID')
        const res = await GetUser(userId)
        if (!res) { return }
        if (!'data' in res) {
            console.log("Could not get user")
            return
        }

        const user = res.data
        if (!user) { return }
        if (!'teams' in user) {
            console.log("User does not have any teams")
            return
        }

        const inLeague = user.teams.find((team) => team.leagueId == _leagueId)
        if (inLeague) {
            navigate(`/League?leagueId=${_leagueId}`)
        }
    }


    //Save the team 
    const saveTeam = async () => {
        const userId = localStorage.getItem('userID')
        const idArray = team.map(rider => rider._id);

        const data = {
            userId: userId,
            leagueId: leagueId,
            riders: idArray
        }
        const res = await AddTeam(data)

        if (res) {
            navigate(`/league?leagueId=${leagueId}`)
        }
    }

    //Gets the list of all riders
    const getRiders = async () => {
        const riders = await GetRiders()

        if (!riders) { return }
        if (riders.data.length == 0) { return }

        const sorted = [...riders.data].sort((a, b) => b.value - a.value);
        const _countries = [...new Set(riders.data.map(obj => obj.country))].sort((a, b) => a.localeCompare(b));

        setCountries(_countries)
        setRiders(sorted)
        setFilteredRiders(sorted)
        // handleSort()
    }


    const handleFilter = (genderValue, countryValue) => {
        setGenderFilter(genderValue)
        setCountryFilter(countryValue)

        if (genderValue === 'All' && countryValue === 'All') {
            setFilteredRiders(riders);
        } else {
            const genderFilter = genderValue === 'Male' ? 'm' : 'f';
            const filtered = riders.filter((rider) => {
                const isGenderMatch = genderValue === 'All' || rider.gender === genderFilter;
                const isCountryMatch = countryValue === 'All' || rider.country === countryValue;
                return isGenderMatch && isCountryMatch;
            });
            const sorted = [...filtered].sort((a, b) => b.value - a.value);
            setFilteredRiders(sorted);
        }
    }


    const handleSort = () => {
        const sorted = [...filteredRiders].sort((a, b) => b.value - a.value); // Sort riders by value descending
        setFilteredRiders(sorted);
    };


    const getTeamValue = () => {
        if (!team || team.length === 0) {
            return 0; // Return 0 if the team is empty or undefined
        }

        const totalValue = team.reduce((accumulator, rider) => accumulator + rider.value, 0);
        return totalValue;
    }

    const getLeague = async () => {
        const res = await GetLeaguesByIds([_leagueId])

        try {
            if (!res || !res.data) { return null }
            if (res.data.length == 0) { return null }

            const _league = res.data[0]
            setLeague(_league)

            if (_league.numberMaleRiders != undefined || _league.numberMaleRiders != null) { setNumMaleRiders(_league.numberMaleRiders) }
            if (_league.numberFemaleRiders != undefined || _league.numberFemaleRiders != null) { setNumFemaleRiders(_league.numberFemaleRiders) }

            getMatchingTeams(_league)

            return _league
        } catch (error) {
            console.log(error)
            return null
        }
    }


    const getMatchingTeams = async (_league) => {
        const userId = localStorage.getItem('userID')

        const res = await GetMatchingTeams({ leagueId: _league._id, userId: userId })
        if (!res || !res.data) { return }
        console.log(res.data)
        setMatchingTeams(res.data)
    }

    const handleImportTeam = async (_team) => {
        try {
            const res = await GetTeamRiders(_team.teamId)

            if (!res || !res.data) { return }

            const _riders = res.data

            const _femaleRiders = _riders.filter(rider => rider.gender === "f")
            const _femaleCount = _femaleRiders.length
            const _maleCount = 6 - _femaleCount
            const totalValue = _riders.reduce((accumulator, rider) => accumulator + rider.value, 0);

            setFemaleCount(_femaleCount)
            setMaleCount(_maleCount)
            setTeamValue(totalValue)
            setTeam(_riders)
            setShowImportTeam(false)
        } catch (error) {
            console.log(error)
            return
        }

    }


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const _leagueIdParam = params.get('leagueId');
        setLeagueId(_leagueIdParam)
        setGenderFilter('All')
        getRiders()
        checkIfUserInLeague()
        const _league = getLeague()

    }, []);


    const renderMatchingTeams = (_team, index) => {
        return (<>
            <Card className="my-2" bg='light' >
                <Card.Body className="p-2">
                    <div className="row px-4">
                        <div className="col-sm-3 fw-light d-flex align-items-center">{_team.leagueName}</div>
                        <div className="col d-flex justify-content-sm-end align-items-center">
                            <Button variant="outline-primary" onClick={() => handleImportTeam(_team)}>Import Team</Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>)
    }

    const renderCountriesFilter = (country, index) => {
        return (
            <>
                <Dropdown.Item value={country} onClick={(e) => handleFilter(genderFilter, e.target.text)}>{country}</Dropdown.Item>
            </>
        )
    }

    const renderRiders = (rider, index) => {
        const isInTeam = team.some((teamRider) => teamRider._id === rider._id);
        const teamFull = (Array.isArray(team) && team.length == 6)
        const teamValueLimit = rider.value + teamValue > 30 ? true : false
        const femaleCountFull = femaleCount >= numFemaleRiders ? true : false
        const maleCountFull = maleCount >= numMaleRiders ? true : false

        let riderDisabled = false
        if (isInTeam || teamFull || teamValueLimit || (rider.gender == 'f' && femaleCountFull) || (rider.gender == 'm' && maleCountFull)) {
            riderDisabled = true
        }

        return (
            <div>
                <Card className="my-2" bg='light' >
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name}<span className="fw-light fs-6 ms-1">({rider.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider?.team}</div>
                            <div className="col-sm fs-6 d-flex align-items-center  fw-light">{rider.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light justify-content-sm-end">${(rider.value * 50000).toLocaleString()}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light flex-row justify-content-end">
                                {riderDisabled ? <Button disabled variant="outline-secondary" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button> : <Button variant="dark" onClick={() => addToTeam(rider)}><IoIosAdd size={20} className="mb-1 me-2"></IoIosAdd>Add Rider</Button>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    const renderTeam = (rider, index) => {
        return (
            <div>
                <Card className="my-2" bg='light'>
                    <Card.Body className="p-2">
                        <div className="row px-4">
                            <div className="col-sm d-flex flex-row align-items-center"> <Card.Title className="fs-6"><span className="fw-light fs-6">{rider.first_name} </span>{rider.last_name} <span className="fw-light fs-6 ms-1">({rider.gender}) </span></Card.Title></div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider.team}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">{rider.country}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light">${(rider.value * 50000).toLocaleString()}</div>
                            <div className="col-sm fs-6 d-flex align-items-center fw-light d-flex flex-row justify-content-end">
                                <Button variant="outline-danger" onClick={() => removeFromTeam(rider)}><TiUserDelete size={20} className="mb-1 me-2"></TiUserDelete>Remove</Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }

    return (
        <div className="container pt-3" style={{ backgroundColor: 'white' }}>
            <Helmet>
                <title>Create Team - Downhill MTB Fantasy</title>
                <meta name="description" content="Create your own fantasy team for the downhill mountain biking league. Choose your riders, strategize, and aim for the top of the rankings." />
            </Helmet>
            <div className=" mt-2 d-flex flex-row justify-content-sm-center fw-bold fs-4 ">{league?.name}</div>
            <div className="mb-2 d-flex flex-row justify-content-sm-center fw-light fs-6 ">{league?.description}</div>
            <div className="px-3 pb-1 transition">
                <div className="my-3"> <span className="fw-bold">Rules: </span>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> You may edit your team as many times as you would like.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Team editing is locked 24 hours before next event qualifying date.</div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> You have $1,500,000 to spend. </div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Select {numMaleRiders} Male Riders. </div>
                    <div className="ms-3 fw-light"><GiBulletBill></GiBulletBill> Select {numFemaleRiders} Female Riders. </div>
                </div>
                <Accordion defaultActiveKey={'0'} alwaysOpen>
                    <Accordion.Item eventKey="0" >
                        <Accordion.Header>
                            <div className="row w-100">
                                <div className="col-sm-6">
                                    {Array.isArray(team) ?
                                        <div className="h4">Selected {team.length} of 6 riders</div> : <div className="h4">Select 6 riders</div>
                                    }
                                </div>
                                <div className="col-sm-6 d-flex flex-row justify-content-end pe-5">
                                    <div className="h4">Remaining: ${((30 - teamValue) * 50000).toLocaleString()}</div>
                                </div>
                            </div>

                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="row">
                                <div className="col-sm-2 fw-light">Female riders: {femaleCount}/{numFemaleRiders}</div>
                                <div className="col-sm-2 fw-light">Male riders: {maleCount}/{numMaleRiders}</div>
                            </div>

                            <div className="">
                                {Array.isArray(team) && team.map(renderTeam)}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <div className="d-flex flex-row justify-content-end pt-3">
                    <Button disabled={(Array.isArray(matchingTeams) && matchingTeams.length == 0)} variant="outline-secondary me-2" onClick={() => setShowImportTeam(true)}><BiImport size={20} className="mb-1 me-2"></BiImport>Import Team</Button>
                    <Button disabled={teamValue > 30 || (Array.isArray(team) && team.length < 6) || (maleCount != numMaleRiders || femaleCount != numFemaleRiders)} onClick={() => saveTeam()}><FiSave size={20} className="mb-1 me-2"></FiSave>Save Team</Button>
                </div>

            </div>
            <hr></hr>
            <div className="px-3 py-2 transition">
                <div className="row mb-3">
                    <div className="col-lg-1 h4 me-lg-4">Riders</div>
                    {/* <div className="col-md-1 fw-light d-flex flex-row align-items-center justify-content-md-end">Filters:</div> */}
                    <div className="col-lg-1 d-flex align-items-center fw-light justify-content-lg-end">Gender:</div>
                    <div className="col-lg-1 d-flex flex-row justify-content-start">
                        <DropdownButton onChange={(e) => handleFilter(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={genderFilter} className="">
                            <Dropdown.Item value='All' onClick={(e) => handleFilter(e.target.text, countryFilter)}>All</Dropdown.Item>
                            <Dropdown.Item value='Male' onClick={(e) => handleFilter(e.target.text, countryFilter)}>Male</Dropdown.Item>
                            <Dropdown.Item value='Female' onClick={(e) => handleFilter(e.target.text, countryFilter)}>Female</Dropdown.Item>
                        </DropdownButton>
                    </div>
                    <div className="col-lg-1 d-flex align-items-center fw-light justify-content-lg-end">Country:</div>
                    <div className="col-lg d-flex flex-row justify-content-start">
                        <DropdownButton onChange={(e) => console.log(e.target.value)} id="dropdown-basic-button" variant='outline-secondary' title={countryFilter} className="">
                            <Dropdown.Item value='All' onClick={(e) => handleFilter(genderFilter, 'All')}>All</Dropdown.Item>
                            {Array.isArray(countries) && countries.map(renderCountriesFilter)}
                        </DropdownButton>
                    </div>
                </div>

                {Array.isArray(filteredRiders) && filteredRiders.map(renderRiders)}
            </div>


            <Modal size='lg' show={showImportTeam} onHide={() => setShowImportTeam(false)}>
                <Modal.Header closeButton>
                    <BiImport size={24} className="me-2"></BiImport>
                    <Modal.Title>Import Team</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label className="fw-light">Import a completed team from a different league. </Form.Label>
                    <Form.Label className="fw-lighter">Note: The leagues listed below have a matching amount of male and female riders.</Form.Label>
                    {Array.isArray(matchingTeams) && matchingTeams.map(renderMatchingTeams)}
                    {Array.isArray(matchingTeams) && matchingTeams.length == 0 && <div className="mx-5 mt-4" style={{color: 'red'}}>**No teams found with matching parameters</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="px-4" onClick={() => setShowImportTeam(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}

export default CreateTeam;